import { useState, useEffect } from "react";
import { getCountdown } from "@/lib/helpers";

const Unit = ({ value, label }) => (
  <div className="flex flex-col items-center" data-testid={`countdown-${label.toLowerCase()}`}>
    <span className="font-serif text-4xl sm:text-6xl md:text-7xl font-light tracking-tighter tabular-nums text-white leading-none">
      {String(value).padStart(2, "0")}
    </span>
    <span className="mt-2 text-[10px] sm:text-xs tracking-[0.25em] uppercase text-primary/80">{label}</span>
  </div>
);

export default function Countdown({ startDate }) {
  const [cd, setCd] = useState(getCountdown(startDate));

  useEffect(() => {
    const t = setInterval(() => setCd(getCountdown(startDate)), 1000);
    return () => clearInterval(t);
  }, [startDate]);

  if (!cd) return null;

  if (cd.past) {
    return (
      <p className="font-serif text-3xl sm:text-4xl font-light gold-text tracking-tighter" data-testid="countdown-status">
        {cd.days === 0 ? "Your journey begins today" : "Your journey is underway"}
      </p>
    );
  }

  return (
    <div className="flex items-start justify-center gap-4 sm:gap-8" data-testid="countdown-timer">
      <Unit value={cd.days} label="Days" />
      <span className="font-serif text-4xl sm:text-6xl text-primary/40 leading-none">:</span>
      <Unit value={cd.hours} label="Hours" />
      <span className="font-serif text-4xl sm:text-6xl text-primary/40 leading-none">:</span>
      <Unit value={cd.minutes} label="Minutes" />
      <span className="font-serif text-4xl sm:text-6xl text-primary/40 leading-none">:</span>
      <Unit value={cd.seconds} label="Seconds" />
    </div>
  );
}
